import axios from "axios";
import { requiredParam } from "@utils/func";

const getUserCompanies = ({ userId = requiredParam("userId") } = {}) => {
  return axios.get(`users/${userId}/companies`);
};

const getUserBureauCompanies = ({ userId = requiredParam("userId") } = {}) => {
  return axios.get(`users/${userId}/bureaus`);
};

export { getUserCompanies, getUserBureauCompanies };
